import { getVariableName } from "./css-variables";

/**
 * Map Name -> Value to usable css variable / raw value for css / js context.
 *
 * @param values Name -> Value Map
 * @param prefix Specific css variable prefix
 * @returns Map of Name -> CSS Variable + Name -> Raw Value
 */
export const createCSSValues = <T>(values: Record<string, string>, prefix = "") =>
  Object.entries(values).reduce(
    (acc, [name]) => ({
      ...acc,
      [name]: `var(${getVariableName(name, prefix)})`,
    }),
    {
      raw: values,
    } as T,
  );
